import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import BasePlayerEmbed from "./BasePlayerEmbed";

var KalturaPlayerEmbed = function KalturaPlayerEmbed(_ref) {
  var videoId = _ref.videoId,
      extra = _objectWithoutProperties(_ref, ["videoId"]);

  var frameUrl = videoId;
  return /*#__PURE__*/React.createElement(BasePlayerEmbed, _extends({
    src: frameUrl,
    player: "kaltura"
  }, extra));
};

export default KalturaPlayerEmbed;